import Vue from 'vue';
import HipAPI from '@/lib/HipApi';
import * as VueGoogleMaps from 'vue2-google-maps';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import Auth0Plugin from './plugins/Auth0Lock';
import Notifier from './plugins/notifier';
import Config from './config';
import '@/styles/global.css';

Vue.prototype.$hipApi = HipAPI.getInstance();

Vue.config.productionTip = false;

// Global components
Vue.component('InnerLayout', () => import('@/components/InnerLayout.vue'));
Vue.component('TextBox', () => import('@/components/TextBox.vue'));
Vue.component('Table', () => import('@/components/Table.vue'));
Vue.component('Select', () => import('@/components/Select.vue'));
Vue.component('RightOverlay', () => import('@/components/RightOverlay.vue'));
Vue.component('DatePicker', () => import('@/components/DatePicker.vue'));
Vue.component('DateRangePicker', () => import('@/components/DateRangePicker.vue'));
Vue.component('DateGroupPicker', () => import('@/components/DatesGroupPicker.vue'));
Vue.component('Autocomplete', () => import('@/components/Autocomplete.vue'));
Vue.component('CountryCodeSelector', () => import('@/components/CountryCodeSelector.vue'));

Vue.use(VueGoogleMaps, {
    load: {
        key: Config.value('VUE_APP_GOOGLE_MAPS_KEY'),
        libraries: 'places',
    },
});

Vue.use(Auth0Plugin, {
    domain: Config.value('VUE_APP_AUTH0_DOMAIN'),
    clientId: Config.value('VUE_APP_AUTH0_CLIENT_ID'),
    audience: Config.value('VUE_APP_AUTH0_AUDIENCE'),
    onRedirectCallback: (appState: any) => {
        router.push(
            appState && appState.targetUrl
                ? appState.targetUrl
                : window.location.pathname,
        );
    },
});

Vue.use(Notifier, { store });

const v = new Vue({
    router,
    store,
    vuetify,
    data() {
        return {
            ready: false,
        };
    },
    watch: {
        // eslint-disable-next-line
        '$auth.authenticated': async function (val: boolean) {
            if (val) {
                try {
                    const corp = await this.$hipApi.getCorpDetails();
                    store.commit('offices/setCorp', corp);

                    const texts = await this.$hipApi.getTexts();
                    store.commit('texts/setTexts', texts);

                    const tenants = await this.$hipApi.getTenants();
                    store.commit('tenants/setTenants', tenants);

                    this.$mount('#app');
                    const corpSettings = await this.$hipApi.getCorpSettings();
                    store.commit('corporate/setCorporate', corpSettings);

                // can't start app without knowing user's office and without received the texts kit
                } catch (error) {
                    this.$notifier.showError('Couldn\'t reach network');
                    console.error(error?.error?.message || error?.message || error);
                }
            }
        },
    },
    render: (h) => h(App),
});
